import React from 'react';
import { useState } from "react";


// import React, { useState, useEffect } from "react";

const Location = () => {

    const [data, setData] = useState([
      {
        "a": "ZfIRaOukT5f5IpHRv3tUKVOweriRzWI0hbOtFLGBLmdcwOPa0uXKN0Iwm7hrsN8d6DFuEPQHVxFQCrhaU/E=",
        "b": "4xeGhivMHue6aC/UpRYlaQQnWQKqEjuv625iEVLTGttmmbrwKfzj24uSqhu4pV1bJBto",
        "c": "vO1ywLXwnEQoqmXpre6cj6iK3u7M+EvJZu9f/dbUFUv9YEjQitsQfjb/SaaXqLIBPTWS3g==",
        "d": "vAhQjNXY5tVmFj8wiudR0n1EYaQS8h3OJAZS0XaCTOoqmqtN32rLSHx29nJYnTFrPo0tsq5IQunsQwUCHTwA4PLDzqaXVVvDzI9+2Rl7zsxpHZY6Ysxwp17o"
      },
      {
        "a": "eMP3NQob3KVywKzDuDcsYmA9zQQ6wfbCH5N+LGqZxh8EZdO8ya1pf/LENbSNzDyXozDANb5yESJ6adsjQA==",
        "b": "rHLCFq1GAJxCc+DbYYl2muN8EC6x//1Kn1ppsb3c3XoUxOwKGZBA0txlkpwWt1x61rd5m5C8hhivZOfPrg==",
        "c": "OVubh+JnynIk821rVpVYoP5o3IsqwOFW6qWBLhWhcVYp9CsBMkMQKOyry/T7K9eL34alKIWWSaUUBngHrA==",
        "d": "RdtEQBGygSEAJrbnoSHw8j+g+f8uppWlidTrkf65fALs20hs2gKkFnCbUT4jbPH/g5QHrdkjcxxafUdXKrHg1uetdzJ1Z5w8iOAMtuCmtJjmFFJYQVnQjAIjNLRz2/qaLtWLXpu1XrKYCbmdFQ=="
      },
      {
        "a": "X23sHFQfzIDhOVoVyFw8uZ0QuUg+LgacUWHaua5QlU0+US5w2mrEczuYGMduIp8V59WNags0Io365L/TgKyc68g=",
        "b": "oNkbwOkwJmFGQwIvmIDvRUqQ3ey3z5FpQAV3QUsCjeazCXB5s5ppD2iHO/WXi6ykLX0WmIs=",
        "c": "elK3FFGbGsIwSvBs1OaqxL4G9lfQYQwoTuXB/Wr5OuFemtT0ds9P3vEzQAgxEvakuLAVhJc=",
        "d": "JVzS+r0lP+0wWAwGC4jCLlT8Q3Pq7kW97zuBMFgOMEXHnBcadyY9tx5lQ37gbEmIajOTw2Q77HwcI181QXbU794jXFiEgIhN6ws6V+QAT2BMxNYfRFV5FA5gJS3e"
      },
      {
        "a": "SmehXAfrpLe8UDD0onkvsu8zfDw1WStscnsYXoFH4U/NPCxx7K8htXkj9EfEYl+5+sp3y9XB+pJQIgj2toih/w==",
        "b": "Xj0lfwEDCwZwuL5E3aS7ryv5yRO9CkK80nFYmmDxB8uyb46/f1nQ5KVM6ogMKm8y8P7Exrw=",
        "c": "CgYL9eVSZN70stutHjyjCrLfQLfYKnM9m7LHiTd5/lvabc7/Fkh3F94lNXpXIFyPLNK9ig8=",
        "d": "xHT4s4F1uBIkJmB3rE7UGRStvgXIuNMPu2h6oXzJvaNZ4uqXsLOJePM2ICaJrKu6dx6rnIGAd8YJtzln+W1vss7G9dA7Sw/5ILvZzITmp2atbLFNkC5KHuKNmXgo"
      },
      {
        "a": "iOSAFzwTDnBbzjMmgSeT+kEmZFObaM1AlGpMXkZzAlvLtyLKvzDAc9Nh84lSj+U/JuRgpcoe",
        "b": "XW7Pczb//T0Auuihg3DNPUd5pN+3jwyKIL9CaLvkJEQOk7qSfUwPUidoCj73q951siRw/2U=",
        "c": "9ScwCXG3m0Jx8MCBYE5eKyLkuTswXjWNwAZ/yxBKoF4pmtNiPHEf28BofbFDdlk7b1jcnrQ=",
        "d": "taVDNLbNQ6THXsHuSbQfKAOlZHcRnYjGRYabBM5Za/faxjHo/qo79Uc/nZMiuEt8T7fekCSDj+x0o54m8outdC5Lz8VtAOeSqCXdSN64Usnfd0tUjfjIJDtqlo8i"
      },
      {
        "a":"Q0Bfd8ZIl9hkIGZNIMZhsnATGi+MSl8PPAt1tRk+nhca9il5yLN0UyGA4KipK6xScbm+gUI10afj",
        "b":"fztXLIOJDKPzCJGYrVL90jzA9p40hHhPzBSxj5AfKNAnJa5dEbjSbIQPJy83+q+u8sIVPOM=",
        "c":"WEgTY4jgd+HTtsezkzORs0bj20Be5YCW/PVR7bWGkTKKGhabgu0VUEz5KLgwkzTk20b5Vew=",
        "d":"qxOw4TkIFmSskbd2+kGk8k8y6wvuFBUbBKDOWEQxpnVF8/lyvv0tggtJ0dXHK/mscrUKYLwKIy7cVTjYsUsQMnukgldSOmU62h0e4fFoxqCPUImi/UhYtAFhjM80",
      },
      {
        "a":"yAt2nOtrPpdhzTS8muSk1adzIgxafLOGuyCNXpaXQjrF4497EWkrq2kmiK6OC35HyMQhcgSneA==",
        "b":"mgauvnAvCtkWdaj+uRw3r7xSAS7/V+EBczVaNHtFzWMUZOqY0S2sV2L9SyjMN8wDrUtWdik=",
        "c":"852WEzW6y97DzRJ6HbmGPLrgUDohsZ51nBNewne4W3BFwDrGKfgWwhgFuvY8RvYss/o3t/w=",
        "d":"6rBQydTjK/zAoyrPI9KBLdkzgmo+MrD9V1gfUZ6+b/kc7xSXNj1wnkcRQBONOlEl9Q6HfXuCZyJhUo6bpLUSmlgMRd7q972HxPnOrVh0qRQCP0pF7X2uO8sL9HFf",
      },
      {
        "a":"cF90jhzWP9m7vUPd/VvrHElPSKNSRSNf91YqgjizF+7Utqr2rF/eZwurz3sqkjG30zc=",
        "b":"q/Wi3AOZKGd98Xdf+i4hGW6TG56OsFjh7AV1zRoGEBcLI5MLyT8XWTxlMd4yZWJrwWHIILs=",
        "c":"rpiKWaSfIXVkfsWIsyqb4jD4A2+PuuMu+IOcGuB+/nUHJDn8szn4XE/v2tjCUGNk6GRcnp8=",
        "d":"KHcuqEFKu2veASlYV3ICzV11fzLYO/pm0VHdFPtRtd1B5WUF9QfIcH13ypmHrmD6k7AVkMm5nJt8cQlFZDrWUTowSeSzGKEpX5lXWI5i1m0Cltcf3JJ0kuKWBQ4a",
      }
  ]);
  

  const encoder = new TextEncoder();
  const decoder = new TextDecoder();

  const bufferToBase64 = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf)));
  const base64ToBuffer = (b64) => Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));

  async function getKey(password, salt) {
    const keyMaterial = await window.crypto.subtle.importKey(
      "raw",
      encoder.encode(password),
      "PBKDF2",
      false,
      ["deriveKey"]
    );
    return window.crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt,
        iterations: 100000,
        hash: "SHA-256",
      },
      keyMaterial,
      { name: "AES-GCM", length: 256 },
      false,
      ["encrypt", "decrypt"]
    );
  }

  async function aesEncrypt(plainText, password) {
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const salt = crypto.getRandomValues(new Uint8Array(16));
    const key = await getKey(password, salt);
    const encrypted = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      key,
      encoder.encode(plainText)
    );
    const combined = new Uint8Array([...salt, ...iv, ...new Uint8Array(encrypted)]);
    return bufferToBase64(combined);
  }

  async function aesDecrypt(encryptedBase64, password) {
    try {
      const combined = base64ToBuffer(encryptedBase64);
      const salt = combined.slice(0, 16);
      const iv = combined.slice(16, 28);
      const ciphertext = combined.slice(28);
      const key = await getKey(password, salt);
      const decrypted = await crypto.subtle.decrypt(
        { name: "AES-GCM", iv },
        key,
        ciphertext
      );
      return decoder.decode(decrypted);
    } catch (e) {
      return Array.from({ length: 30 }, () =>
        Math.random().toString(36).charAt(2)).join('');
    }
  }

  const handleEncrypt = async () => {
    const key = document.getElementById("encryptKey").value;
    if (!key) return alert("Enter a key to encrypt.");

    const encryptedData = await Promise.all(
      data.map(async (item) => {
        const newItem = {};
        for (let prop in item) {
          newItem[prop] = typeof item[prop] === "string" ? await aesEncrypt(item[prop], key) : item[prop];
        }
        return newItem;
      })
    );
    setData(encryptedData);
  };

  const handleDecrypt = async () => {
    const key = document.getElementById("decryptKey").value;
    if (!key) return alert("Enter a key to decrypt.");

    const decryptedData = await Promise.all(
      data.map(async (item) => {
        const newItem = {};
        for (let prop in item) {
          newItem[prop] = typeof item[prop] === "string" ? await aesDecrypt(item[prop], key) : item[prop];
        }
        return newItem;
      })
    );
    setData(decryptedData);
  };

  return (
    <div className="container" style={{ maxWidth: 900, margin: "0 auto", background: "#fff", padding: 30, borderRadius: 15, boxShadow: "0 8px 20px rgba(0,0,0,0.1)" }}>
      <h2 style={{ textAlign: "center", color: "#333" }}>Coordinates</h2>
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 20 }}>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td style={{ maxWidth: "100px", overflow: "hidden", padding: "14px 18px" }}>{row.a}</td>
              <td style={{ maxWidth: "100px", overflow: "hidden", padding: "14px 18px" }}>{row.b}</td>
              <td style={{ maxWidth: "100px", overflow: "hidden", padding: "14px 18px" }}>{row.c}</td>
              <td style={{ maxWidth: "100px", overflow: "hidden", padding: "14px 18px" }}><a href={row.d} target="_blank" rel="noopener noreferrer">link</a></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="controls" style={{ marginTop: 30, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
        <div className="field-group" style={{ flex: "1 1 45%" }}>
          <label htmlFor="encryptKey">Encryption Key:</label>
          <input type="password" id="encryptKey" placeholder="Enter encryption key" />
          <button onClick={handleEncrypt}>Encrypt</button>
        </div>
        <div className="field-group" style={{ flex: "1 1 45%" }}>
          <label htmlFor="decryptKey">Decryption Key:</label>
          <input type="password" id="decryptKey" placeholder="Enter decryption key" />
          <button onClick={handleDecrypt}>Decrypt</button>
        </div>
      </div>
    </div>
  );
};

export default Location;
